import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Loader, SparklesIcon } from 'components/common';

const GenerateButtons = ({
  onClear,
  onSubmit,
  loading = false,
  disabled,
  generateButtonRef,
  hasGeneratedMessage,
  isGenerating = false,
}) => {
  return (
    <div
      style={{
        marginBottom: '16px',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Button size='middle' onClick={onClear} disabled={loading || disabled}>
        Clear all
      </Button>
      {!isGenerating ? (
        <Button
          ref={generateButtonRef}
          type='primary'
          size='middle'
          icon={
            !hasGeneratedMessage ? (
              <SparklesIcon style={{ marginRight: '6px' }} />
            ) : (
              <Icon size='sm' icon='refresh' style={{ marginRight: '6px' }} />
            )
          }
          style={{ display: 'inline-flex', alignItems: 'center' }}
          disabled={loading || disabled}
          onClick={onSubmit}
        >
          {!hasGeneratedMessage ? 'Generate message' : 'Generate again'}
        </Button>
      ) : (
        <Loader className='button-loader' />
      )}
    </div>
  );
};

GenerateButtons.propTypes = {
  onClear: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  generateButtonRef: PropTypes.object.isRequired,
  hasGeneratedMessage: PropTypes.bool.isRequired,
  isGenerating: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default GenerateButtons;
